import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionSummary, {
    AccordionSummaryProps,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Faq from '../../../API/faq';
import { useTranslation } from 'react-i18next';

const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },

}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: '#fe7f2d' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fff',
    color: '#fe7f2d',
    fontSize: '12rem',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function FaqEtude() {

    interface Faq{
        id_faq:number,
        user_category:number,
        question:string,
        fr_question:string,
        answer:string,
        fr_answer:string
    }
    const [expanded, setExpanded] = React.useState<string | false>('panel1');
    const [questions,setQuestions] = React.useState<Faq[]>();

    const GetListQuestions = ()=>{
        Faq.GetListeFaq().then((res:any)=>{
           if(res.data.status === 200){
             setQuestions(res.data.web_faq)
           }
        }).catch((err:any)=>{
            console.log(err)
        })
    }

    React.useEffect(()=>{
         GetListQuestions();
    },[])
    

    const handleChange =
        (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
            setExpanded(newExpanded ? panel : false);
        };

        const { t, i18n } = useTranslation();
       // Si vous devez préciser explicitement les types :
    type TFunctionType = (key: string) => string;

    const langue = i18n.language === 'fr_FR' ? 'fr':'en_US';

  return (
    //   <div className='md:px-12 s:px-5 mt-10'>
    //       <div style={{ color: '#4e4e4e' }} className='uppercase text-2xl font-semibold pb-8'>questions fréquentes</div>
    //       <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
    //           <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
    //               <Typography >Comment faire pour avoir un visa étudiant pour le Canada ?</Typography>
    //           </AccordionSummary>
    //           <AccordionDetails>
    //               <Typography>
    //                   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    //                   malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
    //                   sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
    //                   sit amet blandit leo lobortis eget.
    //               </Typography>
    //           </AccordionDetails>
    //       </Accordion>
    //       <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
    //           <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
    //               <Typography>Quel est le prix d'un visa étudiant canadien ?</Typography>
    //           </AccordionSummary>
    //           <AccordionDetails>
    //               <Typography>
    //                   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    //                   malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
    //                   sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
    //                   sit amet blandit leo lobortis eget.
    //               </Typography>
    //           </AccordionDetails>
    //       </Accordion>
    //       <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
    //           <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
    //               <Typography>Quel est le délai de traitement d'un permis d'étude ?</Typography>
    //           </AccordionSummary>
    //           <AccordionDetails>
    //               <Typography>
    //                   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    //                   malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
    //                   sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
    //                   sit amet blandit leo lobortis eget.
    //               </Typography>
    //           </AccordionDetails>
    //       </Accordion>

    //       <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
    //           <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
    //               <Typography >Quel est le délai de traitement d'un CAQ</Typography>
    //           </AccordionSummary>
    //           <AccordionDetails>
    //               <Typography>
    //                   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    //                   malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
    //                   sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
    //                   sit amet blandit leo lobortis eget.
    //               </Typography>
    //           </AccordionDetails>
    //       </Accordion>
    //       <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
    //           <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
    //               <Typography>Quel université ou Cegep choisir pour avoir le visa d'etude ?</Typography>
    //           </AccordionSummary>
    //           <AccordionDetails>
    //               <Typography>
    //                   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    //                   malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
    //                   sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
    //                   sit amet blandit leo lobortis eget.
    //               </Typography>
    //           </AccordionDetails>
    //       </Accordion>
    //       <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
    //           <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
    //               <Typography>Qui peut être garant pour un étudiant Canada ?</Typography>
    //           </AccordionSummary>
    //           <AccordionDetails>
    //               <Typography>
    //                   Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
    //                   malesuada lacus ex, sit amet blandit leo lobortis eget. Lorem ipsum dolor
    //                   sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
    //                   sit amet blandit leo lobortis eget.
    //               </Typography>
    //           </AccordionDetails>
    //       </Accordion>
    //   </div>

    <div className='md:px-12 s:px-5 mt-10'>
    <div style={{ color: '#4e4e4e' }} className='uppercase text-2xl font-semibold pb-8'>questions fréquentes</div>
    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
            <Typography >Comment faire pour avoir un visa étudiant pour le Canada ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
            {
                questions?.map((quest,index)=>(
                    <Typography key={index}>
                        {langue === 'fr' ? quest?.fr_answer : quest?.answer}
                   </Typography>
                ))
            }
        </AccordionDetails>
    </Accordion>
    <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
            <Typography>Quel est le prix d'un visa étudiant canadien ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
            {
                questions?.map((quest,index)=>(
                    <Typography key={index}>
                        {quest?.fr_answer}
                   </Typography>
                ))
            }
        </AccordionDetails>
    </Accordion>
    <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
            <Typography>Quel est le délai de traitement d'un permis d'étude ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {
                questions?.map((quest,index)=>(
                    <Typography key={index}>
                        {quest?.fr_answer}
                   </Typography>
                ))
            }
        </AccordionDetails>
    </Accordion>

    <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
        <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
            <Typography >Quel est le délai de traitement d'un CAQ</Typography>
        </AccordionSummary>
        <AccordionDetails>
        {
                questions?.map((quest,index)=>(
                    <Typography key={index}>
                        {quest?.fr_answer}
                   </Typography>
                ))
            }
        </AccordionDetails>
    </Accordion>
    <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
        <AccordionSummary aria-controls="panel5d-content" id="panel5d-header">
            <Typography>Quel université ou Cegep choisir pour avoir le visa d'etude ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
           {
                questions?.map((quest,index)=>(
                    <Typography key={index}>
                        {quest?.fr_answer}
                   </Typography>
                ))
            }
        </AccordionDetails>
    </Accordion>
    <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
        <AccordionSummary aria-controls="panel6d-content" id="panel6d-header">
            <Typography>Qui peut être garant pour un étudiant Canada ?</Typography>
        </AccordionSummary>
        <AccordionDetails>
        {
                questions?.map((quest,index)=>(
                    <Typography key={index}>
                        {quest?.fr_answer}
                   </Typography>
                ))
            }
        </AccordionDetails>
    </Accordion>
</div>
  )
}

export default FaqEtude